import React, { useState } from "react";

import styles from "./FinancialPasswordModal.module.css";
import { changeFinancialPassword } from "../../../../Component/function/FinancialApi";

const FinancialPasswordModal = ({
  open,
  onClose,
}) => {
  const [currentPassword, setCurrentPassword] =
    useState("");

  const [newPassword, setNewPassword] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  const [success, setSuccess] =
    useState("");

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    if (!currentPassword.trim()) {
      setError("من فضلك أدخل كلمة المرور الحالية");
      return;
    }

    if (!newPassword.trim()) {
      setError("من فضلك أدخل كلمة المرور الجديدة");
      return;
    }

    if (newPassword.length < 6) {
      setError(
        "كلمة المرور الجديدة يجب أن تكون 6 أحرف على الأقل"
      );
      return;
    }

    if (currentPassword === newPassword) {
      setError(
        "كلمة المرور الجديدة يجب أن تكون مختلفة عن الحالية"
      );
      return;
    }

    try {
      setLoading(true);

      const response =
        await changeFinancialPassword(
          currentPassword,
          newPassword
        );

      if (response.data?.statusCode === 200) {
        setSuccess(
          response.data?.message ||
            "تم تغيير كلمة المرور بنجاح"
        );

        setCurrentPassword("");
        setNewPassword("");

        setTimeout(() => {
          onClose();
          setSuccess("");
        }, 1500);
      } else {
        setError(
          response.data?.message ||
            "حدث خطأ أثناء تغيير كلمة المرور"
        );
      }
    } catch (error) {
      console.error(error);

      setError(
        error.response?.data?.message ||
          "كلمة المرور الحالية غير صحيحة أو حدث خطأ"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (loading) return;

    setCurrentPassword("");
    setNewPassword("");
    setError("");
    setSuccess("");

    onClose();
  };

  return (
    <div className={styles.overlay}>
      <div
        className={styles.modal}
        dir="rtl"
      >
        <button
          type="button"
          className={styles.close}
          onClick={handleClose}
          disabled={loading}
        >
          ×
        </button>

        <div className={styles.header}>
          <div className={styles.icon}>
            🔐
          </div>

          <h2>تغيير كلمة المرور</h2>

          <p>
            قم بإدخال كلمة المرور الحالية ثم كلمة
            المرور الجديدة
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label>
              كلمة المرور الحالية
            </label>

            <input
              type="password"
              value={currentPassword}
              onChange={(e) => {
                setCurrentPassword(e.target.value);
                setError("");
              }}
              placeholder="أدخل كلمة المرور الحالية"
              disabled={loading}
            />
          </div>

          <div className={styles.field}>
            <label>
              كلمة المرور الجديدة
            </label>

            <input
              type="password"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setError("");
              }}
              placeholder="أدخل كلمة المرور الجديدة"
              disabled={loading}
            />
          </div>

          {error && (
            <div className={styles.error}>
              {error}
            </div>
          )}

          {success && (
            <div className={styles.success}>
              {success}
            </div>
          )}

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={handleClose}
              disabled={loading}
            >
              إلغاء
            </button>

            <button
              type="submit"
              className={styles.submitButton}
              disabled={loading}
            >
              {loading
                ? "جاري التغيير..."
                : "تغيير كلمة المرور"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FinancialPasswordModal;